import AgencyConfiguration from '@/utils/api/odas/agency_configuration';
import useApi from './useApi';

export default function useAgencyConfiguration() {
  const { responseData } = useApi(() => AgencyConfiguration.get());

  return {
    agencyConfiguration: responseData?.agency_configuration
  };
}
